/**
 * Adds a query param to a url.
 */
export const addQueryParam = (
  url: string,
  key: string,
  value: string,
): string => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${key}=${value}`;
};

/**
 * Replaces the host of a given URL with a new host.
 */
export const replaceUrlHost = (url: string, newHost: string): string => {
  const u = new URL(url);

  // Normalize new host
  const normalized = newHost.startsWith('http')
    ? newHost
    : `https://${newHost}`;
  const n = new URL(normalized);

  if (u.host === n.host) {
    return url;
  }

  u.protocol = n.protocol;
  u.host = n.host;

  return u.toString();
};
